angular.module('impactx.cscontract').controller('CSContractProductGroupsDataCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToastService',
    'BackService',
    'ToolbarService',
    'PartialDialogsService',
    CSContractProductGroupsDataCtrl]);

function CSContractProductGroupsDataCtrl($scope, dataGen, $routeParams, ToastService, BackService, ToolbarService, PartialDialogsService) {
    var self = this;
    $scope.selectedPriceGroup = {};

    self.save = function ($event) {
        return dataGen.postAsForm($scope, {productGroupsData: $scope.data}, "/cscontract/productgroups/save").then(function (data) {
            ToastService.openStandardToastAfterSaveSuccess($scope, data);
            PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.CONTRACT, $routeParams.id, 'cscproductgroups', $routeParams.preSetId ? $routeParams.preSetId : 0);
        });
    };

    dataGen.getData($scope, {cscId: $routeParams.id}, "/cscontract/productgroups/view").then(function () {
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }
}